import { Component, Input } from '@angular/core';
import { AlertType } from '@app/core/domain';

@Component({
  selector: 'ingo-alert',
  styleUrls: ['./alert.component.scss'],
  template: `<div class="alert alert-{{ type }} text-center p-2">{{ message }}</div>`
})
export class AlertComponent {
  @Input() id: number;
  @Input() type: AlertType;
  @Input() message: string;
}
